<ng-template #arucoItem let-item let-source="source">
  @if (item.type === 'file') {
    <pxc-picture-aruco
      [source]="source"
      (arucoDetectedChange)="onArucoDetected(item, $event)"
      (arucoSurfaceChange)="onArucoSurface(item, $event)" />
  } @else {
    <pxc-sequence-media class="block size-full" [media]="item.media" [showStickerStatus]="true" />
  }
</ng-template>

<ng-container *transloco="let t">
  <div class="flex min-h-0 flex-col gap-6">
    <span class="text-text-tertiary">{{ subtitle }}</span>

    <pxc-media-picker
      #picker="pxcMediaPicker"
      [groups]="groups()"
      [isItemSelectable]="isItemSelectable"
      [itemTemplate]="arucoItem"
      [maxSelectable]="1"
      [validators]="validators"
      (uploadedFilesChange)="onUploadedFilesChange($event)" />

    <div class="flex gap-2 max-md:flex-col-reverse md:items-center">
      <button appearance="outline" tuiButton type="button" [disabled]="isConfirming()" (click)="onCancelled()">
        {{ t('Annuler') }}
      </button>
      <button
        class="md:ml-auto"
        data-testid="picture-provider-confirm"
        tuiButton
        type="button"
        [disabled]="picker.isConfirmDisabled() || isConfirming()"
        [loading]="isConfirming()"
        (click)="onConfirmed(picker.selection())">
        {{ confirmLabel }}
      </button>
    </div>
  </div>
</ng-container>
